<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2021-10-19 11:28:56
 * @LastEditTime: 2021-10-19 11:28:57
-->
<template>
  <div class="about">
    <el-empty description="待施工"></el-empty>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>